export const GET_BIILS = 'GET_BIILS';
export const BILLS_RECEIVED = 'BILLS_RECEIVED';
export const UPDATE_BILL = 'UPDATE_BILL';
export const CREATE_BILL = 'CREATE_BILL';
export const DELETE_BILL = 'DELETE_BILL';
export const UPDATE_BILL_RECEIVED = 'UPDATE_BILL_RECEIVED';
export const CREATE_BILL_RECEIVED = 'CREATE_BILL_RECEIVED';
export const DELETE_BILL_RECEIVED = 'DELETE_BILL_RECEIVED';
